module.exports = __webpack_public_path__ + "static/media/Lys.1e90c3ad.PNG";